import type { MenuInfo } from 'rc-menu/lib/interface'
import { outLogin } from '@/services'
import { LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons'
import { useEmotionCss } from '@ant-design/use-emotion-css'
import { history, useModel } from '@umijs/max'
import { Spin } from 'antd'
import React, { useCallback } from 'react'
import { flushSync } from 'react-dom'
import HeaderDropdown from '../HeaderDropdown'

export interface GlobalHeaderRightProps {
  menu?: boolean
  children?: React.ReactNode
}

export function AvatarName() {
  const { initialState } = useModel('@@initialState')
  const { currentUser } = initialState || {}
  return <span className='anticon'>{currentUser?.username}</span>
}

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu, children }) => {
  /**
   * 退出登录，并且将当前的 url 保存
   */
  const loginOut = async () => {
    await outLogin()
    const { search, pathname } = window.location
    const urlParams = new URL(window.location.href).searchParams
    /** 此方法会跳转到 redirect 参数所在的位置 */
    const redirect = urlParams.get('redirect')
    // Note: There may be security issues, please note
    if (window.location.pathname !== '/login' && !redirect) {
      history.replace({
        pathname: '/login',
        search: JSON.stringify({
          redirect: pathname + search
        })
      })
    }
  }
  const actionClassName = useEmotionCss(({ token }) => {
    return {
      'display': 'flex',
      'height': '48px',
      'marginLeft': 'auto',
      'overflow': 'hidden',
      'alignItems': 'center',
      'padding': '0 8px',
      'cursor': 'pointer',
      'borderRadius': token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover
      }
    }
  })
  const { initialState, setInitialState } = useModel('@@initialState')

  const onMenuClick = useCallback(
    (event: MenuInfo) => {
      const { key } = event
      if (key === 'logout') {
        flushSync(() => {
          setInitialState(s => ({ ...s, currentUser: undefined }))
        })
        loginOut()
        return
      }
      history.push(`/account/${key}`)
    },
    [setInitialState]
  )

  const loading = (
    <span className={actionClassName}>
      <Spin
        size='small'
        style={{
          marginLeft: 8,
          marginRight: 8
        }} />
    </span>
  )

  if (!initialState)
    return loading

  const { currentUser } = initialState

  if (!currentUser || !currentUser.username)
    return loading

  const menuItems = [
    ...(menu
      ? [
          {
            key: 'center',
            icon: <UserOutlined />,
            label: '个人中心'
          },
          {
            key: 'settings',
            icon: <SettingOutlined />,
            label: '个人设置'
          },
          {
            type: 'divider' as const
          }
        ]
      : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录'
    }
  ]

  return (
    <HeaderDropdown
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems
      }}
      placement='top'>
      {children}
    </HeaderDropdown>
  )
}

export default AvatarDropdown
